import { RouteComponentProps } from "react-router-dom";

export const searchParams = (search: string) => {
  return new URLSearchParams(search);
};

export const searchRouteParams = (props: RouteComponentProps) => {
  const splited = props.location.search.split("?");
  const search = splited.length > 1 && splited[1].length ? `?${splited[1]}` : "";
  return searchParams(search);
};

export const deleteSearchRouteParam = (props: RouteComponentProps, param: string) => {
  const splited = props.location.search.split("?");
  const search = splited.length > 1 && splited[1].length ? `?${splited[1]}` : "";

  if (!search) {
    return "";
  }

  return search
    .split("&")
    .filter(searchParam => searchParam.indexOf(param) === -1)
    .join("&");
};

const parseSearchQuery = (search: string) => {
  const result = search.split("?");
  return result.length > 1 && result[1].length ? result[1].toString() : "";
};

export const searchParamsFromQuery = (search: string) => {
  const result = parseSearchQuery(search);
  return searchParams(result);
};

export const deleteSearchParam = (search: string, param: string) => {
  const result = parseSearchQuery(search);

  if (!result) {
    return "";
  }

  return result
    .split("&")
    .filter(searchParam => searchParam.indexOf(param) === -1)
    .join("&");
};
